/**
 * MONSTER TOWN — SCENE IDS AND THE ICE CREAM MENU. VENUE CREW. DATA ONLY.
 *
 * Pulled into its own file so the fixture files can read the menu without
 * importing `venue.ts` back (and creating a cycle). Everything here is
 * re-exported from `venue.ts`, which stays the one import path for the crew.
 */

import type { PlaceableId, SceneId, VenueId } from '../core/types'
import type { VenueItem } from '../venue/types'


/**
 * SCENE IDS ARE A CROSS-CREW CONTRACT. The world crew's buildings declare
 * `toScene: 'venue_iceCream' | 'venue_restaurant' | 'shop'`, so those are the
 * ids these interiors must register under — tap their ice cream shop's front
 * door and you land in this venue. Ids are also SAVE DATA: never rename one.
 */
export const ICE_CREAM_SCENE = 'venue_iceCream' as SceneId
export const RESTAURANT_SCENE = 'venue_restaurant' as SceneId
export const TOWN_SHOP_SCENE = 'shop' as SceneId
export const ICE_CREAM_VENUE = 'iceCream1' as VenueId
export const RESTAURANT_VENUE = 'restaurant1' as VenueId

const id = (s: string): PlaceableId => s as PlaceableId

// ---------------------------------------------------------------------------
// THE MENU — pure data. Availability is derived from what is actually BUILT,
// so a customer never asks for a flavour the kid has not bought yet.
// ---------------------------------------------------------------------------

export const ICE_CREAM_ITEMS: readonly VenueItem[] = [
  { id: 'base_cone', kind: 'base', color: 'cone', shape: 'cone', stationDefId: id('venue_cones') },
  { id: 'base_cup', kind: 'base', color: 'plate', shape: 'cup', stationDefId: id('venue_cups') },
  { id: 'scoop_vanilla', kind: 'scoop', color: 'iceVanilla', shape: 'ball', stationDefId: id('venue_tub_vanilla') },
  { id: 'scoop_strawberry', kind: 'scoop', color: 'iceStrawberry', shape: 'ball', stationDefId: id('venue_tub_strawberry') },
  { id: 'scoop_chocolate', kind: 'scoop', color: 'iceChocolate', shape: 'ball', stationDefId: id('venue_tub_chocolate') },
  { id: 'scoop_mint', kind: 'scoop', color: 'iceMint', shape: 'ball', stationDefId: id('venue_tub_mint') },
  { id: 'scoop_blueberry', kind: 'scoop', color: 'iceBlueberry', shape: 'ball', stationDefId: id('venue_tub_blueberry') },
  { id: 'top_cherry', kind: 'topping', color: 'cherry', shape: 'cherry', stationDefId: id('venue_top_cherry') },
  { id: 'top_sprinkles', kind: 'topping', color: 'flowerPink', shape: 'sprinkles', stationDefId: id('venue_top_sprinkles') },
  { id: 'top_sauce', kind: 'topping', color: 'iceChocolate', shape: 'sauce', stationDefId: id('venue_top_sauce') },
]

